import { SocialLinksConfig } from "@ui/context/component-config-context";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const socialLinksConfig: RecursivePartial<SocialLinksConfig> = {
  linkData: {
    facebook: "https://www.facebook.com/verge",
    threads: "https://www.threads.net/@verge",
    instagram: "https://www.instagram.com/verge",
    youtube: "https://www.youtube.com/user/theverge",
    rss: "https://www.theverge.com/rss/index.xml",
  },
  componentContext: {},
};

export default socialLinksConfig;
